import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const DeleteRowButton = ({ onClick, disabled }) => {
  const { t } = useTranslation(['promptbar']);

  return (
    <Tooltip title={t('delete')} arrow placement="right">
      <span>
        <IconButton
          size="sm"
          aria-label="delete row"
          disabled={disabled}
          onClick={onClick}
        >
          <DeleteIcon
            sx={{
              fontSize: 'var(--font-size-xl)',
              color: 'var(--color-red-main)',
            }}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
};

DeleteRowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DeleteRowButton;
